import { render, staticRenderFns } from "./Js.vue?vue&type=template&id=44f4c844&scoped=true&"
import script from "./Js.vue?vue&type=script&lang=js&"
export * from "./Js.vue?vue&type=script&lang=js&"
import style0 from "./Js.vue?vue&type=style&index=0&id=44f4c844&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f4c844",
  null
  
)

export default component.exports